import React from 'react';
import Header from '../components/Layout/Header';
import Sidebar from '../components/Layout/Sidebar';
import { useSelector } from "react-redux";
import MyPostWidgetRedux from '../widgets/MyPostWidgetRedux';
import BentoFeed from '../widgets/BentoFeed';
import MixedSponsoredAds from '../components/Sponsored/MixedSponsoredAds';
import RecommendedFriends from '../components/Followers/RecommendedFriends';
import EventCarousel from '../components/Events/EventCarousel';

const HOME_BENTO_LAYOUT = Object.freeze({
  initialBatchSize: 10,
  batchSize: 8,
  adInterval: 6,
});

const HOME_LEFT_RAIL_WIDGETS = [
  {
    id: 'recommended-friends',
    className: '',
    render: () => <RecommendedFriends />,
  },
  {
    id: 'events-near-you',
    className: 'home-bento-rail-card-events',
    render: ({ mobile = false } = {}) => (
      <EventCarousel
        showTitle
        mobileRail={mobile}
        title="Events Near You"
        railVariant={mobile ? 'compact' : 'sidebar-card'}
      />
    ),
  },
];

const HOME_RIGHT_RAIL_WIDGETS = [
  {
    id: 'sponsored-ads',
    className: 'home-bento-rail-card-ads',
    render: () => <MixedSponsoredAds />,
  },
];

const renderRailWidget = (widget, options = {}) => (
  <section key={widget.id} className={`home-bento-rail-card ${widget.className}`.trim()}>
    {widget.render(options)}
  </section>
);


const LandingPageTest = () => {
  const currentProfile = useSelector((state) => state.user.currentProfile);
  const { user } = useSelector((state) => state.user);
  const { seller } = useSelector((state) => state.seller);
  
  const picturePath = user?.picturePath;
  const userId = user?._id;
  const sellerId = seller?._id;
  const ownerId = currentProfile === 'User' ? userId : sellerId;
  const homeMobileRailWidgets = [...HOME_LEFT_RAIL_WIDGETS, ...HOME_RIGHT_RAIL_WIDGETS];

  return (
    <div className="main-feed-page">
      <Header />
      <Sidebar />
      
      <div className="main-feed-page-container">
        
        {/* Main content area with bento feed */}
        <main className="main-feed-page-main-content">
          <div className="home-bento-heading-row">
            <h2 className="explore-title">Home</h2>
          </div>

          <section className="home-bento-composer-slot">
            <MyPostWidgetRedux picturePath={picturePath} />
          </section>

          <div className="home-bento-mobile-rail" aria-label="Home widgets">
            {homeMobileRailWidgets.map((widget) => renderRailWidget(widget, { mobile: true }))}
          </div>

          <BentoFeed
            ownerId={ownerId}
            profileType={currentProfile}
            isProfile={false}
            layoutConfig={HOME_BENTO_LAYOUT}
          />
        </main>

        <aside className="main-feed-page-sticky-sidebar-left">
          <div className="home-bento-rail">
            {HOME_LEFT_RAIL_WIDGETS.map((widget) => renderRailWidget(widget))}
          </div>
        </aside>

        <aside className="main-feed-page-sticky-sidebar-right">
          <div className="home-bento-rail">
            {HOME_RIGHT_RAIL_WIDGETS.map((widget) => renderRailWidget(widget))}
          </div>
        </aside>
      </div>
    </div>
  );
};


export default LandingPageTest;
